/** Safe helpers for incomplete store openingHours payloads. */

export type OpeningHoursDay = {
  from?: string | null;
  to?: string | null;
};

export type OpeningHoursPayload = {
  default?: Record<string, OpeningHoursDay | null | undefined> | null;
} | null | undefined;

export const OPENING_HOURS_DAY_KEYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export type OpeningHoursDayKey = (typeof OPENING_HOURS_DAY_KEYS)[number];

export function getOpeningHoursDay(
  openingHours: OpeningHoursPayload,
  dayKey: string
): OpeningHoursDay | undefined {
  const day = openingHours?.default?.[dayKey];
  return day ?? undefined;
}

/** Returns "HH:MM - HH:MM" or the closed label when data is missing/incomplete. */
export function formatOpeningHoursDayRange(
  openingHours: OpeningHoursPayload,
  dayKey: string,
  closedLabel = 'Fechado'
): string {
  const hours = getOpeningHoursDay(openingHours, dayKey);
  const from = typeof hours?.from === 'string' ? hours.from.trim() : '';
  const to = typeof hours?.to === 'string' ? hours.to.trim() : '';
  if (!from || !to) return closedLabel;
  return `${from} - ${to}`;
}

export function hasOpeningHoursData(openingHours: OpeningHoursPayload): boolean {
  const days = openingHours?.default;
  if (!days || typeof days !== 'object') return false;
  return Object.values(days).some((day) => {
    const from = typeof day?.from === 'string' ? day.from.trim() : '';
    const to = typeof day?.to === 'string' ? day.to.trim() : '';
    return !!(from && to);
  });
}
